var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCostumer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 21.2976C34.4554 19.7232 33.2553 18.3319 31.5859 17.3396C29.9164 16.3473 27.871 15.8094 25.7667 15.8094C23.6624 15.8094 21.617 16.3473 19.9475 17.3396C18.2781 18.3319 17.078 19.7232 16.5334 21.2976M19.4666 25C18.922 23.4255 17.7219 22.0342 16.0525 21.0419C14.383 20.0496 12.3376 19.5118 10.2333 19.5118C8.12903 19.5118 6.08357 20.0496 4.41414 21.0419C2.74471 22.0342 1.54462 23.4255 1 25M30.5462 5.93647C30.5462 8.66281 28.4063 10.8729 25.7667 10.8729C23.127 10.8729 20.9872 8.66281 20.9872 5.93647C20.9872 3.21013 23.127 1 25.7667 1C28.4063 1 30.5462 3.21013 30.5462 5.93647ZM15.0128 9.63883C15.0128 12.3652 12.8729 14.5753 10.2333 14.5753C7.59365 14.5753 5.45379 12.3652 5.45379 9.63883C5.45379 6.91249 7.59365 4.70235 10.2333 4.70235C12.8729 4.70235 15.0128 6.91249 15.0128 9.63883Z",
    stroke: "#3C4469",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostumer);
export default __webpack_public_path__ + "static/media/costumer.0ec4d594153898bc85c02462fa0cbd1f.svg";
export { ForwardRef as ReactComponent };